import React from "react";
import styles from "./SubNav.module.css";
import { Link } from "gatsby";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretLeft, faCaretRight, faAngleDoubleRight, faAngleDoubleLeft} from "@fortawesome/free-solid-svg-icons";
import getClickableProps from "../Clickble/Clickable";

const SubNav = ({links, headerClass}) => {
    const scrollRef = React.useRef()
    React.useEffect(
        () => {
            const current = scrollRef.current
            if (current) {
                const handler = (e) => {
                    current.scrollLeft += e.deltaY
                    e.preventDefault()
                }
                const scrollHandler = (e) => {
                    if (current.scrollLeft > 10) {
                        setShowMobileOverflowLeft(true)
                    } else {
                        setShowMobileOverflowLeft(false)
                    }
                    if (current.scrollLeft > current.scrollWidth - window.innerWidth - 20) {
                        setShowMobileOverflowRight(false)
                    } else {
                        setShowMobileOverflowRight(true)
                    }
                }
                current.addEventListener("wheel", handler);
                current.addEventListener("scroll", scrollHandler);
                return () => current && current.removeEventListener("wheel", handler) && current.removeEventListener("scroll", scrollHandler)
            }
        }, [scrollRef]
    )

    //setup scroll arrow clicking callbacks
    const onArrowClickDown = (e, positive) => {
        const step = 50 * (positive ? 1 : -1)

        const makeStep = () => {
            if (scrollRef.current) {
                scrollRef.current.scrollLeft += step
            }
        }
        makeStep()

        const interval = setInterval(makeStep, 10)
        window.addEventListener('mouseup', () => clearInterval(interval))
        window.addEventListener('onkeyup', () => clearInterval(interval))
    }

    // setup scroll arrow displaying
    const [isOverflowing, setIsOverflowing] = React.useState(false)
    const [showMobileOverflowLeft, setShowMobileOverflowLeft] = React.useState(false)
    const [showMobileOverflowRight, setShowMobileOverflowRight] = React.useState(true)
    const updateIsOverflowing = React.useCallback(
        () => {
            if (scrollRef.current) {
                setIsOverflowing(scrollRef.current.scrollWidth > scrollRef.current.clientWidth)
            }
        },
        [setIsOverflowing, scrollRef]
    )
    React.useEffect(() => {
        updateIsOverflowing()

        // setup an interval to recheck as the scroll width of the element sometimes lags
        const interval = setTimeout(updateIsOverflowing, 500)
        return () => clearInterval(interval)
    }, [updateIsOverflowing, scrollRef])
    React.useEffect(
        () => {
            if (window) {
                window.addEventListener('resize', updateIsOverflowing)
                return () => window.removeEventListener('resize', updateIsOverflowing)
            }
        },
        [scrollRef, updateIsOverflowing]
    )

    let styleClass;
    if (headerClass === "theme-report-landing") {
        styleClass = styles.ThemeReportSubNav
    }

    return (
        <div className={styles.SubNavHeader}>
            <div className={`${[styles.SubNav, styleClass].join(" ")} ${isOverflowing ? styles.isOverflowing : ''}`} ref={scrollRef}>
                <div className={styles.SubNavWrapper}>
                    {links.map(link =>
                        <Link
                            activeClassName={styles.active}
                            to={link.to}
                            key={link.label}
                        >
                            {link.label}
                        </Link>
                    )}
                </div>
            </div>
            <div
                className={`${styles.scrollButton} ${styles.left} ${isOverflowing ? styles.show : ''}`}
                {...getClickableProps((e) => onArrowClickDown(e, false))}
            >
                <FontAwesomeIcon icon={faCaretLeft} />
            </div>
            <div
                className={`${styles.scrollButton} ${styles.right} ${isOverflowing ? styles.show : ''}`}
                {...getClickableProps((e) => onArrowClickDown(e, true))}
            >
                <FontAwesomeIcon icon={faCaretRight} />
            </div>
            <div
                className={`${styles.overflowGradient} ${styles.overflowGradientLeft} ${isOverflowing && showMobileOverflowLeft ? styles.show : ''}`}
            >
            </div>
            <div
                className={`${styles.overflowGradient} ${styles.overflowGradientRight} ${isOverflowing && showMobileOverflowRight ? styles.show : ''}`}
            >
            </div>
        </div>
    )
}

export default SubNav;